export function formatAmount(data) {
    if(data < 0 ){
      let newData = Math.abs(data)
      return `(${(newData/100.00).toFixed(2)})` 
    }
    return (data/100.00).toFixed(2)
  }
